import React from "react";
import FeatureSection from "../../components/FeatureSection";

// Images
const img1 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810aed_Group%201%20(4).png'; // Reward
const img2 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67fe4885c39a459a65f74e7b_refer%20and%20earn%20(1).png'; // Refer
const img3 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810afd_Group%203.png'; // Performance
const img4 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810add_Frame%202%20(1).png'; // NPS/CSAT
const img5 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b3d_Frame%201%20(2).png'; // Customize mobile review
const img6 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b0d_Frame%203.png'; // AI Surveys
const img7 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b2d_Frame%205%20(1).png'; // Coupons
const img8 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9468bf33e1f9810b1d_Frame%201618869448%20(1).png'; // Campaigns
const img9 = 'https://cdn.prod.website-files.com/67f50baea549023b9a732b20/67f50c9c09fe41e66574086e_3_2%20screen%20mockup%20(3).png'; // Instant Insights

const sections = [
  {
    title: "Reward Stylists for Outstanding Service",
    description:
      "Celebrate your beauty team’s effort in collecting client reviews with rewards that drive motivation and boost morale.",
    image: img1,
    reverse: true,
  },
  {
    title: "Refer a Friend & Grow Your Salon",
    description:
      "Turn happy clients into ambassadors. Offer beauty perks when they refer friends to your salon.",
    image: img2,
  },
  {
    title: "Track Staff Performance & Growth",
    description:
      "Use Zola’s dashboard to see how each beautician performs in terms of reviews, satisfaction, and loyalty.",
    image: img3,
    reverse: true,
  },
  {
    title: "Improve Your Salon's NPS & CSAT Scores",
    description:
      "Empower your team to consistently deliver 5-star experiences by tracking and improving NPS and CSAT metrics.",
    image: img4,
  },
  {
    title: "Personalize Your Mobile Feedback Page",
    description:
      "Design a mobile review experience that matches your salon’s brand, tone, and aesthetic.",
    image: img5,
    reverse: true,
  },
  {
    title: "Let AI Create Smart Feedback Surveys",
    description:
      "Generate intelligent survey questions for your clients with AI and gain actionable insights faster.",
    image: img6,
  },
  {
    title: "Offer Exclusive Beauty Coupons",
    description:
      "Create irresistible limited-time offers and loyalty coupons for your clients — right from your dashboard.",
    image: img7,
    reverse: true,
  },
  {
    title: "Launch Engaging Beauty Campaigns",
    description:
      "Create seasonal or targeted campaigns that promote new services, stylists, or exclusive offers.",
    image: img8,
  },
  {
    title: "Get Instant Insights on Client Satisfaction",
    description:
      "Visualize client feedback trends, top-performing team members, and overall salon satisfaction scores.",
    image: img9,
    showEyebrow: true,
    eyebrow: "Smart Dashboard",
    reverse: true,
  },
];

function AllBeautyFeatures() {
  return (
    <>
      {sections.map((section, index) => (
        <FeatureSection key={index} {...section} />
      ))}
    </>
  );
}

export default AllBeautyFeatures;
